import React, { createContext } from 'react';
import { VehicleBag } from '../../types';
import useStockCar from '../../hooks/useStockCar';

interface VehicleProviderProps {
  children: React.ReactNode;
  isMock: boolean;
  isTier3: boolean;
}

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const vehicleId = new URLSearchParams(locationSearch).get('vehicleId') ?? undefined;
const market = new URLSearchParams(locationSearch).get('market') ?? 'us';
export const source = new URLSearchParams(locationSearch).get('source') ?? undefined;

// This is injected to the application at root level, context will always have a value
export const vehicleContext = createContext<VehicleBag>({} as VehicleBag);
const { Provider } = vehicleContext;

const VehicleProvider: React.FC<VehicleProviderProps> = ({ children, isTier3, isMock }) => {
  const vehicleBag = useStockCar({
    vehicleId,
    market,
    isTier3,
    isMock,
  });

  return <Provider value={vehicleBag}>{children}</Provider>;
};

export default VehicleProvider;
